interface IUseStaticDOM {
    hideElement: (isMobileOnly?: boolean) => void;
    showElement: () => void;
}

const useStaticDOM = (selector: string): IUseStaticDOM => {
    const getElement = (): HTMLElement => {
        return document.querySelector(`:not(#app) > ${selector}`);
    };

    const hideElement = (isMobileOnly = false): void => {
        const element = getElement();

        if (!element) return;

        if (isMobileOnly) {
            element.classList.add("layout-hidden-mobile");
        } else {
            element.classList.add("layout-hidden");
        }
    };

    const showElement = (): void => {
        const element = getElement();

        if (!element) return;

        element.classList.remove("layout-hidden-mobile", "layout-hidden");
    };

    return { hideElement, showElement };
};

export default useStaticDOM;
